module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-3-selected.e116bb98.png";